<template>
  <main>
    <md-card>
      <md-card-header>
        <div class="md-title">お問い合わせ・FAQ</div>
      </md-card-header>

      <loading-spinner v-if="loadList"></loading-spinner>
      <md-card-content v-else-if="errorMessages.length">
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <flash-message :errors="errorMessages"></flash-message>
          </div>
        </div>
      </md-card-content>
      <flash-message v-else-if="errorDeleteMessages.length" :errors="errorDeleteMessages"></flash-message>
      <md-card-content v-if="!loadList">
        <div class="md-layout md-gutter">
          <div class="md-layout md-layout-item md-alignment-center-right md-size-100">
            <router-link :to="{name: 'BackendAdminFaqCategoryNew'}">
              <md-button :disabled="sending" class="md-primary md-raised">
                <md-icon>add</md-icon>
                <span>カテゴリ登録</span>
              </md-button>
            </router-link>
            <router-link :to="{name: 'BackendAdminFaqNew'}">
              <md-button :disabled="sending" class="md-primary md-raised">
                <md-icon>add</md-icon>
                <span>よくある質問登録</span>
              </md-button>
            </router-link>
          </div>
        </div>
      </md-card-content>
      <md-card-content v-if="categories">
        <draggable v-model="categories" group="categories" @start="drag=true" @end="drag=false"
                   handle=".category-handle"
                   class="category-group" @change="categoryChanged">
          <div v-for="category in categories" :key="'category-' + category.id" class="category">
            <div class="category-handle">
              <font-awesome-icon class="category-handle" icon="fa-solid fa-grip-vertical"></font-awesome-icon>
            </div>
            <div class="category-content">
              <div class="category-name">
                <h3>{{ category.name }}</h3>
                <router-link
                    :to="{name: 'BackendAdminFaqCategoryNew', params: {id: category.id.toString()}}">
                  <md-button :disabled="sending" class="md-icon-button" title="編集">
                    <md-icon>edit</md-icon>
                  </md-button>
                </router-link>
                <md-button :disabled="sending" class="md-icon-button md-accent"
                           @click="openPopUpConfirm(category.id, true)" title="削除">
                  <md-icon>delete</md-icon>
                </md-button>
              </div>
              <draggable v-model="category.faqs" :group="'category-' + category.id" @start="drag=true" @end="drag=false"
                         handle=".faq-handle" class="category-draggable" @change="faqChanged(category)">
                <div v-for="faq in category.faqs" :key="'category-' + category.id + '-' + faq.id" class="faq">
                  <div class="faq-question">
                    <div class="faq-handle">
                      <font-awesome-icon class="category-handle" icon="fa-solid fa-grip-vertical"></font-awesome-icon>
                    </div>
                    <div class="faq-question-content">{{ faq.question }}</div>
                    <router-link
                        :to="{name: 'BackendAdminFaqNew', params: {id: faq.id.toString()}}">
                      <md-button :disabled="sending" class="md-icon-button" title="編集">
                        <md-icon>edit</md-icon>
                      </md-button>
                    </router-link>
                    <md-button :disabled="sending" class="md-icon-button md-accent"
                               @click="openPopUpConfirm(faq.id)" title="削除">
                      <md-icon>delete</md-icon>
                    </md-button>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
        </draggable>
      </md-card-content>
      <delete-modal
          :md-active.sync="showDeleteModal"
          :md-title="popupConfirm.title"
          :md-content="popupConfirm.content"
          confirm-button-class="md-accent md-raised"
          cancel-button-class="md-raised"
          @md-cancel="onDeleteCancel"
          @md-confirm="deleteFaqSubmit"/>
      <md-snackbar :md-active.sync="showSnackBar"
                   :md-duration="snackbarDuration"
                   @md-closed="showSnackBar = false">
        <span>{{ successMessage }}</span>
        <md-button class="md-primary" @click="showSnackBar = false">閉じる</md-button>
      </md-snackbar>
    </md-card>
  </main>
</template>

<script>
import FlashMessage                                      from '../../../components/FlashMessage';
import Pagination                                        from '../../../components/Pagination';
import Common                                            from '../../../modules/common';
import CommonMixin                                       from '../../../mixins/commonMixin';
import DeleteModal                                       from '../../../components/DeleteModal';
import {apiClientWithManagerToken as apiClient, apiList} from '../../../modules/apiClient';
import LoadingSpinner                                    from '../../../components/LoadingSpinner';
import draggable                                         from 'vuedraggable'
import {FontAwesomeIcon}                                 from '@fortawesome/vue-fontawesome'
import {library}                                         from '@fortawesome/fontawesome-svg-core'
import {faGripVertical}                                  from '@fortawesome/free-solid-svg-icons'

library.add(faGripVertical)

export default {
  name      : "AdminFaqs",
  mixins    : [CommonMixin],
  components: {
    LoadingSpinner,
    Pagination,
    FlashMessage,
    DeleteModal,
    draggable,
    FontAwesomeIcon,
  },
  data      : () => ({
    sending             : false,
    keyword             : null,
    faqs                : [],
    errorMessages       : [],
    emptyResponseMessage: Common.messages.errorGet,
    errorDeleteMessages : [],
    popupConfirm        : {
      title        : Common.messages.faqList.confirmTitle,
      content      : Common.messages.faqList.confirmContent,
      faqId        : null,
      faqCategoryId: null,
    },
    // Sort config
    sortKey   : 'updated_at',
    statusSort: 'desc',
    columns   : {
      question  : {name: '質問', sort: 'asc'},
      answer    : {name: '回答', sort: 'asc'},
      updated_at: {name: '編集日時', sort: 'desc'},
    },
    loadList  : false,
    categories: [],
  }),
  mounted   : function () {
    this.getFaqs();
    this.getSnackBar();
  },
  methods   : {
    clearData() {
      this.errorDeleteMessages = [];
      this.successMessage      = null;
    },
    getFaqs() {
      this.clearData();
      this.sending  = true;
      this.loadList = true;
      apiClient
          .get(apiList.faq.list)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.categories = response.data;
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sortBy(this.faqs);
            this.sending  = false
            this.loadList = false;
          });
    },
    deleteFaq() {
      this.sending = true;
      apiClient.delete(apiList.faq.delete.replace(':id', this.popupConfirm.faqId))
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.getFaqs();
            this.successMessage = Common.messages.faqList.successDeleteMsg;
            this.showSnackBar   = true;
          })
          .catch(error => {
            this.errorDeleteMessages = [error.message];
          })
          .finally(() => {
            this.sending            = false;
            this.popupConfirm.faqId = null;
          });
    },
    deleteFaqCategory() {
      this.sending = true;
      apiClient.delete(apiList.faqCategory.delete.replace(':id', this.popupConfirm.faqCategoryId))
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.getFaqs();
            this.successMessage = Common.messages.faqList.successDeleteMsg;
            this.showSnackBar   = true;
          })
          .catch(error => {
            this.errorDeleteMessages = [error.message];
          })
          .finally(() => {
            this.sending                    = false;
            this.popupConfirm.faqCategoryId = null;
          });
    },
    openPopUpConfirm(id, isCategory = false) {
      this.showDeleteModal = true;
      if (isCategory) {
        this.popupConfirm.faqId         = null;
        this.popupConfirm.faqCategoryId = id;
        this.popupConfirm.content       = Common.messages.faqList.confirmCategoryContent;
      } else {
        this.popupConfirm.faqCategoryId = null;
        this.popupConfirm.faqId         = id;
        this.popupConfirm.content       = Common.messages.faqList.confirmContent;
      }
    },
    onDeleteCancel() {
      this.showDeleteModal            = false;
      this.popupConfirm.faqId         = null;
      this.popupConfirm.faqCategoryId = null;
    },
    deleteFaqSubmit() {
      this.showDeleteModal = false;
      if (this.popupConfirm.faqId) {
        this.deleteFaq();
      } else {
        this.deleteFaqCategory();
      }
    },
    categoryChanged() {
      this.sending = true;
      apiClient.post(apiList.faqCategory.reorder, {categories: this.categories.map(category => category.id)})
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.successMessage = Common.messages.faqList.successReorderMsg;
            this.showSnackBar   = true;
          })
          .catch(error => {
            this.errorDeleteMessages = [error.message];
          })
          .finally(() => {
            this.sending = false;
          });
    },
    faqChanged(category) {
      this.sending = true;
      apiClient.post(apiList.faq.reorder, {category_id: category.id, faqs: category.faqs.map(faq => faq.id)})
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.successMessage = Common.messages.faqList.successReorderMsg;
            this.showSnackBar   = true;
          })
          .catch(error => {
            this.errorDeleteMessages = [error.message];
          })
          .finally(() => {
            this.sending = false;
          });
    },
  },
}
</script>

<style lang="scss" scoped>
.md-theme-default a:not(.md-button) {
  color: black;
}

a.active {
  font-weight: bold;
  color: black;
}

.md-table-cell {
  min-width: 150px;
}

.category-group {
  .category {
    border: 1px solid gray;
    margin-bottom: 2px;
    display: flex;
    align-items: stretch;

    &.sortable-chosen {
      border: 1px solid blue;
      background: lightgray;
    }

    &-handle {
      padding: 5px;
      cursor: move;
      display: flex;
      align-self: center;
    }

    &-content {
      flex-grow: 1;
      padding: 5px;
      border-left: 1px solid gray;
    }

    &-name {
      font-weight: 700;
      display: flex;

      & h3 {
        flex-grow: 1;
        padding: 3px;
      }
    }

    &-draggable {
      margin: 10px;

      .faq {
        border: 1px solid gray;
        margin-bottom: 1px;

        &.sortable-chosen {
          border: 1px solid blue;
          background: lightgray;
        }

        &-handle {
          padding: 3px;
          cursor: move;
          display: flex;
          align-self: center;
        }

        &-question {
          display: flex;

          &-content {
            flex-grow: 1;
            padding: 5px;
            border-left: 1px solid gray;
          }
        }
      }

    }
  }
}
</style>
